import React from 'react';

export default function PresentationIcon(props) {
  return (
    <svg
      version='1.1'
      id='Capa_1'
      xmlns='http://www.w3.org/2000/svg'
      xlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 512 512'
      xmlSpace='preserve'
      {...props}
    >
      <g>
        <g>
          <path d='M448.004,93c5.523,0,10-4.477,10-10V30c0-16.542-13.458-30-30-30h-398c-16.542,0-30,13.458-30,30v452
			c0,16.542,13.458,30,30,30h398c16.542,0,30-13.458,30-30v-28c0-5.523-4.477-10-10-10s-10,4.477-10,10v28c0,5.514-4.486,10-10,10
			h-398c-5.514,0-10-4.486-10-10V30c0-5.514,4.486-10,10-10h398c5.514,0,10,4.486,10,10v53C438.004,88.523,442.481,93,448.004,93z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M400.01,48H57.998c-5.523,0-10,4.477-10,10v209c0,5.523,4.477,10,10,10s10-4.477,10-10V68H390.01v16
			c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10V58C410.01,52.477,405.533,48,400.01,48z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M65.064,296.93c-1.86-1.86-4.43-2.93-7.07-2.93c-2.63,0-5.21,1.07-7.07,2.93s-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07
			c1.86,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.07-2.93c1.87-1.86,2.93-4.44,2.93-7.07S66.934,298.79,65.064,296.93z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M400.01,422c-5.523,0-10,4.477-10,10v12H67.998V342.5c0-5.523-4.477-10-10-10s-10,4.477-10,10V454c0,5.523,4.477,10,10,10
			H400.01c5.523,0,10-4.477,10-10v-22C410.01,426.477,405.533,422,400.01,422z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M309.908,353.336c-3.905-3.906-10.236-3.906-14.142-0.001L276.002,373.1l-12.285-12.286
			c-7.757-7.756-20.376-7.756-28.133,0l-7.994,7.994c-3.905,3.905-3.905,10.237,0,14.143c3.905,3.905,10.237,3.905,14.143,0
			l7.918-7.918l12.285,12.286c3.878,3.878,8.972,5.817,14.066,5.817s10.188-1.939,14.066-5.817l19.84-19.84
			C313.813,363.574,313.813,357.242,309.908,353.336z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M507.4,209.782c4.407-6.875,5.723-15.343,3.609-23.231c-2.114-7.888-7.486-14.563-14.741-18.313
			c-3.146-1.626-5.072-4.962-4.907-8.499c0.379-8.158-2.715-16.148-8.489-21.923c-5.774-5.774-13.762-8.873-21.923-8.489
			c-3.554,0.172-6.873-1.762-8.499-4.907c-3.75-7.254-10.425-12.627-18.313-14.741c-7.891-2.115-16.356-0.798-23.23,3.609
			c-2.981,1.912-6.833,1.911-9.813,0c-6.875-4.408-15.341-5.723-23.23-3.609c-7.888,2.114-14.563,7.487-18.313,14.741
			c-1.626,3.146-4.971,5.067-8.499,4.907c-8.161-0.381-16.148,2.715-21.922,8.489c-5.775,5.775-8.869,13.765-8.49,21.922
			c0.165,3.538-1.762,6.874-4.907,8.5c-7.254,3.75-12.627,10.424-14.741,18.313c-1.009,3.763-1.228,7.658-0.711,11.449h-174.5
			c-5.523,0-10,4.477-10,10s4.477,10,10,10H305.39c-0.215,0.549-0.464,1.088-0.79,1.596c-4.407,6.875-5.723,15.343-3.609,23.231
			c0.29,1.083,0.647,2.141,1.057,3.173h-176.27c-5.523,0-10,4.477-10,10s4.477,10,10,10h194.265
			c0.435,1.143,0.653,2.376,0.594,3.639c-0.379,8.158,2.715,16.148,8.49,21.923c5.774,5.774,13.761,8.874,21.922,8.489
			c3.533-0.173,6.873,1.761,8.499,4.907c1.201,2.324,2.706,4.451,4.451,6.344v93.393c0,4.04,2.431,7.683,6.161,9.234
			c3.729,1.551,8.027,0.705,10.892-2.145l24.947-24.817l24.947,24.817c1.912,1.902,4.461,2.911,7.055,2.911
			c1.292,0,2.596-0.251,3.837-0.767c3.73-1.551,6.161-5.194,6.161-9.234v-93.393c1.745-1.892,3.25-4.02,4.451-6.344
			c1.626-3.146,4.966-5.068,8.499-4.907c8.166,0.386,16.148-2.714,21.922-8.489c5.775-5.775,8.869-13.765,8.49-21.923
			c-0.165-3.537,1.762-6.873,4.907-8.499c7.254-3.75,12.627-10.424,14.741-18.313c2.114-7.889,0.798-16.356-3.609-23.232
			C505.488,216.615,505.488,212.763,507.4,209.782z M427.999,380.642l-14.948-14.87c-3.901-3.881-10.204-3.881-14.105,0
			l-14.947,14.87V320.65c5.983,0.282,11.979-1.282,17.094-4.56c2.981-1.912,6.833-1.911,9.813,0
			c4.723,3.028,10.197,4.597,15.72,4.597c0.458,0,0.915-0.023,1.373-0.045V380.642z M491.69,237.651
			c-0.67,2.501-2.307,4.534-4.607,5.723c-10.064,5.203-16.228,15.877-15.701,27.195c0.121,2.587-0.822,5.02-2.653,6.852
			c-1.831,1.831-4.264,2.771-6.851,2.653c-11.324-0.524-21.992,5.636-27.195,15.701c-1.189,2.301-3.222,3.937-5.724,4.607
			c-2.5,0.669-5.08,0.27-7.259-1.128c-4.77-3.058-10.235-4.586-15.702-4.586c-5.465,0-10.932,1.529-15.701,4.586
			c-2.18,1.397-4.759,1.797-7.26,1.128c-2.502-0.67-4.534-2.307-5.724-4.607c-5.203-10.064-15.869-16.23-27.195-15.701
			c-2.581,0.119-5.02-0.822-6.851-2.653c-1.832-1.832-2.774-4.265-2.653-6.853c0.371-7.988-2.602-15.646-7.915-21.295
			c-0.156-0.171-0.315-0.339-0.483-0.499c-2.11-2.139-4.555-3.979-7.303-5.4c-2.3-1.189-3.936-3.221-4.606-5.723
			s-0.27-5.081,1.128-7.26c6.115-9.538,6.115-21.864,0-31.402c-1.397-2.18-1.798-4.759-1.128-7.261
			c0.67-2.501,2.307-4.534,4.607-5.723c10.064-5.203,16.227-15.877,15.701-27.195c-0.121-2.587,0.822-5.02,2.653-6.852
			c1.831-1.832,4.269-2.772,6.851-2.653c11.325,0.525,21.993-5.636,27.195-15.701c1.189-2.301,3.222-3.937,5.724-4.607
			c2.501-0.669,5.08-0.27,7.259,1.128c9.539,6.116,21.866,6.116,31.402,0c2.18-1.397,4.758-1.799,7.26-1.128
			c2.502,0.67,4.534,2.307,5.724,4.607c5.203,10.064,15.876,16.229,27.195,15.701c2.588-0.118,5.02,0.821,6.851,2.653
			c1.832,1.832,2.774,4.265,2.653,6.852c-0.526,11.317,5.636,21.992,15.702,27.195c2.3,1.189,3.936,3.221,4.606,5.723
			c0.67,2.502,0.27,5.081-1.128,7.26c-6.115,9.538-6.115,21.864,0,31.402C491.96,232.57,492.361,235.149,491.69,237.651z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M453.556,187.486c-3.905-3.905-10.237-3.905-14.142,0l-33.191,33.192l-13.213-13.213c-3.905-3.905-10.237-3.905-14.143,0
			c-3.905,3.905-3.905,10.237,0,14.143l20.284,20.284c1.953,1.953,4.512,2.929,7.071,2.929s5.119-0.976,7.071-2.929l40.263-40.263
			C457.461,197.724,457.461,191.392,453.556,187.486z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M122.074,120.93c-1.86-1.86-4.44-2.93-7.07-2.93c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
			s1.07,5.21,2.93,7.07c1.86,1.86,4.44,2.93,7.07,2.93c2.63,0,5.21-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07
			S123.934,122.79,122.074,120.93z'
          />
        </g>
      </g>
      <g>
        <g>
          <path d='M200.997,118H152.33c-5.523,0-10,4.477-10,10s4.477,10,10,10h48.667c5.523,0,10-4.477,10-10S206.52,118,200.997,118z' />
        </g>
      </g>
      <g>
        <g>
          <path d='M302.838,294H188.516c-5.523,0-10,4.477-10,10s4.477,10,10,10h114.321c5.523,0,10-4.477,10-10S308.361,294,302.838,294z' />
        </g>
      </g>
    </svg>

  );
}
